/**
 * Maps an LP product object to a GA4 ecommerce item.
 * item_id/price mirror the confirmation purchase event for downstream consistency.
 */
const CreateEcommerceItem = (product = {}, quantity) => {
	const item = {
		item_id: product?.itemCode,
		item_name: product?.name,
		// Unit price = case salePrice, consistent with existing order-confirmation reporting
		price: product?.skus?.[0]?.salePrice,
		item_category: product?.productType || product?.colourName,
	};

	if (quantity != null) {
		item.quantity = quantity;
	}

	return item;
};

export default CreateEcommerceItem;
